import React, { useEffect } from "react";
import { SendOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditRestaurantDataMutation,
  useFetchRestaurantDataByIdQuery,
  useFetchSelfRestaurantDataQuery,
} from "./restaruant.service";
import { Button, Card, Flex, Form, Input, Select } from "antd";
import { ROLE } from "../../constant";

export default function RestaurantEditPage() {
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const { id } = useParams();

  const {
    data = {
      data: {
        restaurant: {
          owner: {},
          name: "",
          address: { street: "", pincode: "", country: "", city: "" },
        },
      },
    },
    isSuccess,
  } = useFetchRestaurantDataByIdQuery(id);
  const [editRestaurantData, { isSuccess: isEditSuccess }] =
    useEditRestaurantDataMutation();

  useEffect(() => {
    if (isEditSuccess) {
      form.resetFields();
      navigate("/restaurant");
    }
  }, [isEditSuccess]);

  const handleFormSubmit = async (formData) => {
    await editRestaurantData({
      data: { ...formData, tenantId: "tenant id" },
      id,
    });
  };

  const {
    data: {
      restaurant: { owner, name, address },
    },
  } = data;

  useEffect(() => {
    form.setFieldsValue({
      name: name,
      email: owner?.email,
      owner: owner?.name,
      password: "",
      address: address,
    });
  }, [isSuccess]);

  return (
    <Card
      title="Restaurant Update"
      style={{ fontSize: "20px" }}
      bordered={false}
      extra={
        <Button
          type="default"
          style={{ marginRight: 8 }}
          onClick={() => navigate("/restaurant")}
        >
          Discard
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFormSubmit}
        initialValues={{
          email: "",
          password: "",
          owner: "",
          address: {
            street: "",
            city: "",
            country: "",
            pincode: "",
          },
        }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter an Name",
            },
          ]}
        >
          <Input placeholder="Enter Name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter an Email",
            },
            {
              type: "email",
              message: "Please enter a valid email address!",
            },
          ]}
        >
          <Input placeholder="Enter Restaurant Email" />
        </Form.Item>
        {/* <Form.Item
          label="Tenant ID"
          name="tenant_id"
          rules={[
            {
              required: true,
              message: "Please enter an Tenant ID",
            },
          ]}
        >
          <Input placeholder="Enter Tenant ID" />
        </Form.Item> */}

        {/* Password Input */}
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: "Please enter a Password",
            },
          ]}
        >
          <Input.Password placeholder="Enter Password" />
        </Form.Item>
        {/* Owner's Name Input */}
        <Form.Item
          label="Owner's Name"
          name="owner"
          rules={[
            {
              required: true,
              message: "Please enter the owner's name",
            },
          ]}
        >
          <Input placeholder="Eg. John Doe" />
        </Form.Item>
        {/* Street Address Input */}
        <Form.Item
          label="Street"
          name={["address", "street"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the street name",
            },
          ]}
        >
          <Input placeholder="Enter Street" />
        </Form.Item>
        {/* City Input */}
        <Form.Item
          label="City"
          name={["address", "city"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the city",
            },
          ]}
        >
          <Input placeholder="Enter City" />
        </Form.Item>
        {/* Country Input */}
        <Form.Item
          label="Country"
          name={["address", "country"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the country",
            },
          ]}
        >
          <Input placeholder="Enter Country" />
        </Form.Item>
        {/* Pincode Input */}
        <Form.Item
          label="Pincode"
          name={["address", "pincode"]} // Nested field access
          rules={[
            {
              required: true,
              message: "Please enter the pincode",
            },
          ]}
        >
          <Input placeholder="Enter Pincode" />
        </Form.Item>
        <Flex justify="center">
          <Button type="primary" htmlType="submit">
            Update {<SendOutlined />}
          </Button>
        </Flex>
      </Form>
    </Card>
  );
}
